<template>
<!-- 在IP白名单内：进行谷歌令牌验证 -->
	<div class="token-card">
		<!-- 谷歌令牌首次验证 -->
    <a-card class="card first-code" v-if="!isBind" :body-style="{ padding: '31px 31px' }">
      <h2>动态码验证</h2>
      <p>请下载进入Authenticator APP</p>
      <p>扫描二维码后，将获取的动态码输入至下方输入框</p>
      <div class="down">
        <a @click="showModal('iOS')">iOS下载></a>
        <a @click="showModal('Android')">Android下载></a>
      </div>
      <vue-qr
        :text="qrCode"
        :size="200"
        :logoScale="0.2">
      </vue-qr>
      <p class="refresh"><a @click="getQrCode">点击刷新</a></p>
      <a-input v-model="dynamicCode" placeholder="请输入动态码" />
      <p class="refresh"><a @click="openModal('note')">暂不绑定，使用短信验证码登录>></a></p>
      <div>
        <a-button class="first-btn" @click="goBack">返回</a-button>
        <a-button class="first-btn" type="primary" @click="checkQrCode">登录</a-button>
      </div>
    </a-card>

    <!-- 谷歌令牌非首次验证 -->
    <a-card class="card first-code" v-else :body-style="{ padding: '85px 31px' }">
      <h2>动态码验证</h2>
      <p class="not-first">请将Authenticator APP中已生成的动态码输入至下方输入框</p>
      <a-input v-model="dynamicCode" placeholder="请输入动态码" />
      <div class="btn-box">
        <a-button class="first-btn" @click="goBack">返回</a-button>
        <a-button class="first-btn" type="primary" @click="checkQrCode">登录</a-button>
      </div>
      <p class="not-first"><a @click="openModal('note')">使用短信验证码登录>></a></p>
      <div class="again">
        <p class="not-first"><a @click="openModal('again')">重新绑定</a></p>
        <p class="text">若已更换扫码设备或已删除生成的动态码，请点击重新绑定后重新扫码绑定</p>
      </div>
    </a-card>

		<!-- 下载弹窗 -->
    <a-modal :visible="downVisible" :footer="null" :closable="false" width="440px">
      <div class="down-modal">
        <h2>{{ downType === 'iOS' ? 'iOS端下载' : 'Android端下载'}}</h2>
        <img alt="" v-if="downType === 'iOS'" src="../../../assets/images/ios.png" />
        <img alt="" v-else src="../../../assets/images/android.png" />
        <p>{{ downType === 'iOS' ? '请使用相机应用扫码唤起APP Store后直接下载' : '请使用手机浏览器扫码后下载'}}</p>
        <a-button type="primary" @click="clodeDownModal">关闭</a-button>
      </div>
    </a-modal>

		<!-- 重新绑定\短信登录 -->
		<a-modal :visible="visible" :footer="null" :closable="false" width="440px" :maskClosable="false">
      <div class="note">
        <h2>{{ type === 'again' ? '重新绑定验证' : '验证手机号'}}</h2>
        <p>绑定手机号： {{showPhone}}</p>
				<phone-code :code="code" :phoneHint="''" :phone="phone" @getCode="getCode" />
				<p class="tips">{{codeHint}}</p>
				<div v-if="type === 'again'">
					<a-button @click="closeModal">取消</a-button>
					<a-button type="primary" @click="resetQrCode">验证</a-button>
				</div>
        <a-button v-else type="primary" block @click="phoneLogin">登录</a-button>
      </div>
    </a-modal>
	</div>
</template>

<script>
import VueQr from 'vue-qr'
import PhoneCode from './phone-code.vue'

export default {
  props: {
    isBind: Number,
    qrCode: String,
    phone: String,
    showPhone: String,
    codeHint: String,
    googleSecret: String
  },
  data () {
    return {
      // 谷歌令牌验证
      dynamicCode: '',
      // 下载弹窗
      downVisible: false,
      downType: '',
      // 重新绑定\短信登录
      visible: false,
      type: '',
      code: ''
    }
  },
  components: { VueQr, PhoneCode },
  created () {
  },
  watch: {},
  methods: {
    // 下载弹窗打开
    showModal (type) {
      this.downType = type
      this.downVisible = true
    },

    // 关闭下载弹窗
    clodeDownModal () {
      this.downVisible = false
      this.downType = ''
    },

    // 刷新
    getQrCode () {
      this.dynamicCode = ''
      this.$emit('getQrCode')
    },

    // 返回
    goBack () { this.$emit('goBack') },

    // 登录
    checkQrCode () { this.$emit('checkQrCode', this.dynamicCode) },

    // 手机验证弹窗
    openModal (type) {
      this.visible = true
      this.type = type
    },

    closeModal () {
      this.visible = false
      this.type = ''
      this.code = ''
    },

    // 获取code
    getCode (type, code) {
      this.code = code
    },

    // 登录
    phoneLogin () {
      this.$emit('phoneLogin', 'login', this.code)
    },

    // 重新验证
    resetQrCode () {
      this.$emit('phoneLogin', 'reset', this.code)
    }
  }
}
</script>

<style lang="scss" scoped>
.token-card {
	margin-left: 40%;
}
.card {
	width: 460px;
	border-radius: 20px;
	min-width: 450px;
}
.first-code {
	text-align: center;
	h2, .refresh, .ant-input {
		margin-bottom: 10px;
	}
	.down {
		a {
			display: inline-block;
			padding: 3px 15px 0;
		}
	}
	.ant-input {
		width: 200px;
	}
	.first-btn {
		width: 100px;
		margin: 0 10px;
	}
	.btn-box {
		margin-bottom: 30px;
		margin-top: 10px;
	}
	.not-first {
		margin-bottom: 20px;
	}
	.again {
		border-top: 1px solid #ccc;
		padding-top: 13px;

		.text {
			text-align: left;
		}
	}
}
.down-modal {
  text-align: center;
  img {
    width: 250px;
  }
  p {
    margin-bottom: 10px;
  }
  .ant-button {
    width: 100px;
  }
}
.note {
	padding: 20px;
	text-align: center;
	h2 {
		margin-bottom: 20px;
	}
	.tips {
		text-align: left;
		color: red;
		margin-top: 3px;
		height: 25px;
	}
	>div {
		.ant-btn {
			width: 100px;
			margin-right: 15px;
			&:last-child {
				margin: 0;
			}
		}
	}
	.ant-btn {
		margin-top: 20px;
	}
}
</style>
